// source from  https://codepen.io/bbrady/pen/ozrjKE
import PropTypes from 'prop-types'
import React from 'react'
import './styles.css'

function RadialProgress({ sqSize = 200, strokeWidth = 4, percentage = 0, children = null, isMini }) {
  // Size of the enclosing square
  // SVG centers the stroke width on the radius, subtract out so circle fits in square
  const radius = (sqSize - strokeWidth) / 2
  // Enclose cicle in a circumscribing square
  const viewBox = `0 0 ${sqSize} ${sqSize}`
  // Arc length at 100% coverage is the circle circumference
  const dashArray = radius * Math.PI * 2
  // Scale 100% coverage overlay with the actual percent
  const dashOffset = dashArray - dashArray * (percentage / 100)

  return (
    <div
      className={`radial-progress ${
        percentage === 100 ? 'completed' : ''
      }`}
    >
      <div className="widget">
        <svg width={sqSize} height={sqSize} viewBox={viewBox}>
          <circle
            className="circle-background"
            cx={sqSize / 2}
            cy={sqSize / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
          />
          <circle
            className="circle-progress"
            cx={sqSize / 2}
            cy={sqSize / 2}
            r={radius}
            strokeWidth={`${strokeWidth}px`}
            // Start progress marker at 12 O'Clock
            transform={`rotate(-90 ${sqSize / 2} ${sqSize / 2})`}
            style={{
              strokeDasharray: dashArray,
              strokeDashoffset: dashOffset
            }}
          />
          {children || isMini ? null : (
            <text
              className="circle-text"
              x="50%"
              y="50%"
              dy=".3em"
              textAnchor="middle"
            >
              {percentage}
            </text>
          )}
        </svg>
        <div className="content">{children}</div>
      </div>
    </div>
  )
}

RadialProgress.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]),
  sqSize: PropTypes.number,
  percentage: PropTypes.number,
  strokeWidth: PropTypes.number,
  isMini: PropTypes.bool
}

export default RadialProgress
